import React, { useState } from 'react'
import Carousel, { Modal, ModalGateway } from 'react-images'
import {
  CFImage,
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  LocationSelect,
  MobileScreen,
} from 'components'
import { headerbg, logo, logoTitle, logoWhite } from 'images'
import { dispatch } from 'store'

const orderingUrl =
  process.env.REACT_APP_ENVIRONMENT === 'dev'
    ? 'https://demo.codefusion.tech/restaurants/ebisu/locations/ebisuLocation1'
    : 'https://order.codefusion.tech/restaurants/jwtXW2Bc6tUEEYtcnIIt/locations/MvLV4OUJjaddWhfyWwXM'

const images = []

export default () => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <MobileScreen>
        <CFView
          column
          center
          w="100%"
          bg="rgba(0,0,0, 0.8)"
          boxShadow="0 2px 2px rgba(0,0,0,.35)"
          pb="8px"
        >
          <CFView row center>
            <CFImage
              w="100%"
              ph="10px"
              mv="5px"
              ml="5px"
              src={logoWhite}
              alt="Ton Ton Sushi Logo"
            />
          </CFView>
          {/* <CFView mt="-5px">
            <LocationSelect />
          </CFView> */}
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          row
          justifyStart
          zIndex={98}
          bg="rgba(0,0,0, 0.8)"
          boxShadow="2px 2px 4px rgba(0,0,0,.35)"
          h="65px"
          w="100%"
        >
          <CFView
            row
            justifyBetween
            alignCenter
            w="100%"
            maxWidth="1400px"
            ph="30px"
          >
            <CFView row justifyStart alignCenter mv="1px">
              <CFImage
                h="150px"
                ml="10px"
                mt="100px"
                src={logo}
                alt="Ton Ton Sushi Logo"
                zIndex={98}
              />
              <CFImage
                h="45px"
                mt="4px"
                ml="-15px"
                src={logoTitle}
                alt="Ton Ton Sushi Logo"
                zIndex={98}
              />
              {/* <CFSelect selector={dispatch.restaurant.getHasMultipleLocations}>
                <CFView ml="2px" mt="-2px" zIndex={99}>
                  <LocationSelect />
                </CFView>
              </CFSelect> */}
            </CFView>
            {/* <CFView hover mt="12px">
              <CFLink href={orderingUrl}>
                <CFImage
                  h="60px"
                  src={viewMenu}
                  alt="Ton Ton Sushi View Menu Button"
                />
              </CFLink>
            </CFView> */}
          </CFView>
        </CFView>
      </DefaultScreen>
      <ModalGateway>
        {showModal ? (
          <Modal onClose={() => setShowModal(false)}>
            <Carousel views={images} />
          </Modal>
        ) : null}
      </ModalGateway>
    </>
  )
}
